"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_1 = require("./styled");
const Typography_1 = require("../UI/Typography");
const GetInitialData_1 = require("app/Utils/GetInitialData");
const MessageBanner = () => {
    var _a, _b;
    const hydratedInitialData = (0, GetInitialData_1.getInitialData)();
    const isMessageBannerActive = (_a = hydratedInitialData === null || hydratedInitialData === void 0 ? void 0 : hydratedInitialData.Banner) === null || _a === void 0 ? void 0 : _a.IsEnabled;
    const bannerMessage = (_b = hydratedInitialData === null || hydratedInitialData === void 0 ? void 0 : hydratedInitialData.Banner) === null || _b === void 0 ? void 0 : _b.Message;
    return isMessageBannerActive ? (react_1.default.createElement(styled_1.BannerContainer, null,
        react_1.default.createElement(styled_1.BannerText, { dangerouslySetInnerHTML: { __html: bannerMessage }, type: Typography_1.Types.BODY_2 }))) : null;
};
exports.default = MessageBanner;
